﻿import {ExecuteCustomerActionArguments} from "../../types/arguments/ExecuteCustomerActionArguments";
import IPermitsCustomActions from "../IPermitsCustomActions";
import {PermitsFrontClient} from "./PermitsFrontClient";

export class PermitsCustomActions implements IPermitsCustomActions {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	get<T>(data: ExecuteCustomerActionArguments, signal?: AbortSignal | undefined): Promise<T> {
		return this._client.jsonFetch("customer/actions", "PUT", data, {
			signal: signal
		});
	}
}
